import React from 'react'
import { dataLabels } from './vaccine-component-helpers/dataLabels'
import DataTable from './dataTable'
import NumberBreakdown from './numberBreakdown'
import { formatTimestamp } from '../sfc/component-helpers/datehelpers'
import { intword } from '../vaccine/vaccine-component-helpers/intWord'

// columns of data to show in table
const useKeys = ['n', 'num_pv', 'num_fv', 'pop', 'pct_pv', 'pct_fv']

function RateCompareSection({ activeStateObj, allUSData, modDate, marketKey }) {
  let usData = allUSData.find((d) => d.n === 'United States')

  function onSortTable(sortColumn) {
    if (typeof window.ens_specialEvent !== 'undefined') {
      window.ens_specialEvent(
        `Vaccine Tracker ${marketKey}`,
        `Rate compare table sort`,
        `${sortColumn}`
      )
    }
    // } else {
    //   console.log(
    //     'would send GA event',
    //     `Vaccine Tracker ${marketKey}`,
    //     `Rate compare table sort`,
    //     `${sortColumn}`
    //   )
    // }
  }

  function onToggleTable(btnText) {
    if (typeof window.ens_specialEvent !== 'undefined') {
      window.ens_specialEvent(
        `Vaccine Tracker ${marketKey}`,
        `Rate compare table ${btnText}`
      )
    }
    // } else {
    //   console.log(
    //     'would send GA event',
    //     `Vaccine Tracker ${marketKey}`,
    //     `Rate compare table ${btnText}`
    //   )
    // }
  }

  return (
    <section>
      <div className="container">
        <h3 className="subhed">
          {intword(activeStateObj['num_fv'] + activeStateObj['num_pv'])} people
          in {activeStateObj.n} have received at least one shot of the vaccine
        </h3>
        <p>
          The FDA has authorized vaccines for people 16 and older. The Pfizer
          and Moderna vaccines require two doses, while the Johnson & Johnson
          vaccine is administered in a single dose. According to the CDC, people
          are considered fully vaccinated two weeks after receiving their last
          shot.
        </p>
        <p>
          In {activeStateObj.n}, {activeStateObj.num_pv.toLocaleString()} people
          have been <span data-label="pv">partially vaccinated</span> and{' '}
          {activeStateObj.num_fv.toLocaleString()} people have{' '}
          <span data-label="pvf">received all shots.</span> That means{' '}
          {(
            (activeStateObj.num_fv + activeStateObj.num_pv) /
            activeStateObj.pop
          ).toLocaleString('en-US', {
            style: 'percent',
            minimumFractionDigits: 1,
          })}{' '}
          of the population has received at least one shot.
        </p>

        <NumberBreakdown stateData={activeStateObj} usData={usData} />
      </div>
      <DataTable
        data={allUSData}
        rowHeaderKey="n"
        dataLabels={dataLabels}
        maxLength={5}
        highlightRow={activeStateObj.n}
        sortable={true}
        useKeys={useKeys}
        stickyRowHeader={true}
        gaToggleEvent={onToggleTable}
        gaSortEvent={onSortTable}
      />
      <p className="footnote">
        Last updated: {formatTimestamp(modDate)} <br />
        Source: CDC
      </p>
    </section>
  )
}

export default React.memo(RateCompareSection)
